import { TableColumnsType } from "antd";
import { MdOutlineFileDownload } from "react-icons/md";
import { BiError } from "react-icons/bi";
import { Stage } from "@types";

interface Report {
  id: number;
  stage?: Stage;
  regions: { name: string }[];
  countries: { name: string }[];
  from_date: string;
  to_date: string;
  report_on: string[];
  name: string;
}

export const getColumns = ({
  handleRowClick,
}: {
  handleRowClick: (report: any) => void;
}): TableColumnsType<Report> => [
    {
      title: "Region",
      dataIndex: "regions",
      key: "region",
      width: 160,
      render: (regions: Report["regions"]) => regions?.map(r => r.name).join(", "),
    },
    {
      title: "Country",
      dataIndex: "countries",
      key: "country",
      width: 160,
      render: (countries: Report["countries"]) => countries?.map(c => c.name).join(", "),
    },
    {
      title: "Report From",
      dataIndex: "from_date",
      key: "from_date",
      width: 140,
      render: (date: string) => new Date(date).toLocaleDateString(),
    },
    {
      title: "Report Till",
      dataIndex: "to_date",
      key: "to_date",
      width: 140,
      render: (date: string) => new Date(date).toLocaleDateString(),
    },
    {
      title: "Report Type",
      dataIndex: "report_on",
      key: "report_on",
      width: 200,
      render: (list: string[]) => list?.join(", "),
    },
    {
      title: "Report Title",
      dataIndex: "name",
      key: "name",
      width: 220,
    },
    {
      title: "Action",
      key: "action",
      width: 160,
      fixed: "right",
      align: "center",
      render: (report: any) => {
        return <>
          {report?.stage?.key == "Completed" ? <div
            onClick={() => handleRowClick(report)}
            className="table__action__btn table__action__btn--client flex items-center gap-1  text-sm"
          >
            <div>

              <MdOutlineFileDownload className="text-xl" />
            </div>
            <div className="text-sm">
              download
            </div>
          </div> : report?.stage?.key == "Processing" ? <div
            className="table__action__btn table__action__btn--client flex items-center gap-1  text-sm"
          >
            <div className="text-sm">
              Processing
            </div>
          </div> : <div
            className="table__action__btn table__action__btn--client flex items-center gap-1  text-sm"
          >
            <div>
              <BiError className="text-xl " style={{ color: "red" }} />
            </div>
            <div className="text-sm" style={{ color: "red" }}>
              Error
            </div>
          </div>}
        </>
      },
    },
  ];
